import {apiClient} from './axios.ts';
import {
    AdminVoiceItem,
    RegenerateSampleResult,
    UpdateVoiceRequest,
    VoiceSyncResult,
} from '../types/ttsVoice.ts';

export const ttsVoiceApi = {
    list: (lang: string) =>
        apiClient.get<AdminVoiceItem[]>('/admin/tts/voices', {lang}),

    sync: (langCode: string) =>
        apiClient.post<VoiceSyncResult>(`/admin/tts/voices/sync/${langCode}`),

    update: (id: number, body: UpdateVoiceRequest) =>
        apiClient.patch<AdminVoiceItem>(`/admin/tts/voices/${id}`, body),

    regenerateSample: (id: number) =>
        apiClient.post<RegenerateSampleResult>(`/admin/tts/voices/${id}/regenerate-sample`),

    updateSampleText: (code: string, sampleText: string) =>
        apiClient.patchNoData(`/admin/language-specs/${code}/tts-sample-text`, {sampleText}),
};
